import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Opens a page's modal when the URL carries `?<param>=1` (used by the header
 * search's quick actions, e.g. /drivers?new=1), then drops the param so a
 * refresh or back-navigation doesn't reopen it.
 */
export function useOpenFromQuery(open: () => void, param = "new") {
  const [params, setParams] = useSearchParams();
  const flagged = params.get(param) === "1";
  useEffect(() => {
    if (!flagged) return;
    open();
    const next = new URLSearchParams(params);
    next.delete(param);
    setParams(next, { replace: true });
  }, [flagged]);
}
